import { cn } from '@nwwp/ui-shadcn'

type AlignItemsValue = 'flex-start' | 'center' | 'flex-end'

type Props = {
  white?: boolean
  /** @default "center" */
  alignItems?: AlignItemsValue
}

export const Logo = ({ white, alignItems = 'center' }: Props) => {
  const alignClass =
    alignItems === 'flex-start' ? 'items-start' : alignItems === 'flex-end' ? 'items-end' : 'items-center'

  return (
    <div
      data-white={white ? 'true' : 'false'}
      className={cn(
        'flex w-fit flex-col transition-[filter] duration-300 ease-in-out select-none',
        white && 'invert',
        alignClass
      )}
    >
      <span className="text-body-lg !leading-none font-black tracking-[-1px] text-foreground">nerdwallet</span>
      {/* eslint-disable-next-line tailwindcss/no-unnecessary-arbitrary-value -- `leading-0.8!` emits no CSS; unitless 0.8 needs the arbitrary form */}
      <span className="text-title-sm !leading-[0.8] !font-semibold tracking-[-1px] whitespace-nowrap text-foreground italic">
        wealth partners
      </span>
    </div>
  )
}
